import { GgrHistoryEventType, GgrLimitScope } from "./types"

export const GGR_HISTORY_EVENT_LABELS: Record<GgrHistoryEventType, string> = {
  LIMIT_CONFIG_CHANGED: "Limit configuration changed",
  MONTHLY_ROLLOVER: "Monthly rollover",
  SNAPSHOT_UPDATED: "Snapshot updated",
  LIMIT_REACHED: "Limit reached",
  LIMIT_CLEARED: "Limit cleared"
}

export const GGR_SCOPE_TABS: { key: GgrLimitScope; label: string }[] = [
  { key: "CASINO", label: "Casino" },
  { key: "SPORTSBOOK", label: "Sportsbook" }
]
